export const getPanelStageOrigin = (
  panel: { x: number, y: number, width: number, height: number },
  canvasCenter: { x: number, y: number },
) => ({
  x: panel.x + canvasCenter.x - panel.width / 2,
  y: panel.y + canvasCenter.y - panel.height / 2,
  width: panel.width,
  height: panel.height,
});
